import {
  Outlet,
  useLoaderData
} from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuthenticator } from "@aws-amplify/ui-react-core";
import {
  selectIsLoggedIn,
  selectIsLoggingIn,
} from "../../../services/authorization/slices";
import Unauthorized from "../../../Authentication/components/Unauthorized";

function ProtectedRoute() {
  const { authStatus } = useAuthenticator((state) => {
    return [state?.authStatus];
  });
  const loaderData = useLoaderData();
  const { isAuthorized } = loaderData || {};
  const isLoggingIn = useSelector((state) => {
    return authStatus === "configuring" || selectIsLoggingIn(state);
  });
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isLoggingIn) {
    return <div>Logging in</div>;
  }
  if (isAuthorized) {
    return (
      <Outlet
        context={{
          isLoggedIn,
          isAuthorized,
        }}
      />
    );
  }
  return <Unauthorized />;
}

export default ProtectedRoute;
